// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={219}
    height={117}
    viewBox="0 0 219 117"
    {...props}
  >
    <path
      d="M1.18896 13.0238L1.18896 116.67L201.367 116.67V13.0238L1.18896 13.0238Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M29.1867 106.262C34.5467 106.262 38.8919 101.917 38.8919 96.5568C38.8919 91.1967 34.5467 86.8516 29.1867 86.8516C23.8266 86.8516 19.4814 91.1967 19.4814 96.5568C19.4814 101.917 23.8266 106.262 29.1867 106.262Z"
      fill="#EAE8E1"
    />
    <path
      d="M1.18604 12.8347V4.32264C1.188 3.22602 1.6245 2.17488 2.39993 1.39946C3.17535 0.624029 4.22649 0.187527 5.32311 0.185562H197.238C197.783 0.184096 198.322 0.289986 198.826 0.497146C199.329 0.704306 199.787 1.00866 200.173 1.39288C200.559 1.77709 200.866 2.23361 201.075 2.73631C201.284 3.23902 201.393 3.77806 201.394 4.32264V12.8347H1.18604Z"
      fill="#29292F"
    />
    <path
      d="M197.234 0.371706C198.282 0.372688 199.287 0.789202 200.028 1.52988C200.77 2.27056 201.187 3.27496 201.189 4.32293V12.6491H1.3717V4.32293C1.37269 3.2753 1.78929 2.27089 2.53008 1.53011C3.27086 0.789323 4.2753 0.37269 5.32293 0.371706H197.234ZM197.234 1.59799e-06H5.32293C4.17641 1.59799e-06 3.07686 0.45546 2.26615 1.26617C1.45545 2.07687 1 3.17642 1 4.32293V13.0208H201.561V4.32293C201.561 3.75492 201.449 3.1925 201.231 2.66777C201.014 2.14305 200.695 1.66632 200.293 1.26485C199.891 0.863381 199.414 0.54504 198.89 0.328011C198.365 0.110982 197.802 -0.000486801 197.234 1.59799e-06Z"
      fill="#29292F"
    />
    <path
      d="M125.636 27.2949H112.106"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M189.447 27.2949H133.056"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M186.072 32.1074H112.106"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M166 36.918H112.106"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M182.21 36.918H172.516"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M189.949 41.7305H112.106"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M97.5136 52.8535H32.1196V58.9978H97.5136V52.8535Z"
      fill="#29292F"
    />
    <path
      d="M58.7334 95.7333L54.5703 103.435C53.3709 102.784 52.3406 101.861 51.5619 100.74C50.7832 99.6194 50.2777 98.3319 50.0858 96.9807C49.894 95.6295 50.0211 94.2521 50.4571 92.9589C50.8931 91.6657 51.6258 90.4925 52.5965 89.5332L58.7334 95.7333Z"
      fill="#29292F"
    />
    <path
      d="M58.7338 87.3737C60.3872 87.3737 62.0034 87.8639 63.3782 88.7825C64.7529 89.701 65.8244 91.0067 66.4571 92.5342C67.0898 94.0617 67.2554 95.7426 66.9328 97.3642C66.6102 98.9858 65.8141 100.475 64.6449 101.644C63.4758 102.814 61.9863 103.61 60.3647 103.932C58.7431 104.255 57.0622 104.089 55.5347 103.457C54.0072 102.824 52.7016 101.752 51.783 100.378C50.8644 99.0029 50.3742 97.3867 50.3742 95.7333C50.3771 93.5171 51.2588 91.3925 52.8259 89.8254C54.393 88.2583 56.5176 87.3766 58.7338 87.3737ZM58.7338 87.002C57.0069 87.002 55.3188 87.514 53.8829 88.4734C52.4471 89.4328 51.3279 90.7965 50.6671 92.3919C50.0062 93.9874 49.8333 95.743 50.1702 97.4367C50.5071 99.1304 51.3387 100.686 52.5598 101.907C53.7809 103.128 55.3367 103.96 57.0304 104.297C58.7241 104.634 60.4797 104.461 62.0751 103.8C63.6706 103.139 65.0342 102.02 65.9936 100.584C66.953 99.1483 67.4651 97.4602 67.4651 95.7333C67.4656 94.5865 67.2401 93.4509 66.8015 92.3914C66.3629 91.3318 65.7197 90.3691 64.9089 89.5582C64.098 88.7473 63.1353 88.1042 62.0757 87.6656C61.0162 87.227 59.8805 87.0015 58.7338 87.002Z"
      fill="#29292F"
    />
    <path
      d="M186.73 9.3335C187.961 9.3335 188.96 8.335 188.96 7.10328C188.96 5.87155 187.961 4.87305 186.73 4.87305C185.498 4.87305 184.5 5.87155 184.5 7.10328C184.5 8.335 185.498 9.3335 186.73 9.3335Z"
      fill="#FCFBF7"
    />
    <path
      d="M194.343 9.14735C195.472 9.14735 196.387 8.23205 196.387 7.10297C196.387 5.97389 195.472 5.05859 194.343 5.05859C193.214 5.05859 192.298 5.97389 192.298 7.10297C192.298 8.23205 193.214 9.14735 194.343 9.14735Z"
      stroke="#FCFBF7"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M97.5137 67.2227H32.1196"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M97.5137 71.1445H32.1196"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M97.5137 75.0645H32.1196"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M201.048 60.4316H132.64V112.318H201.048V60.4316Z"
      fill="#EAE8E1"
    />
    <path
      d="M87.8417 95.7319L93.5994 89.1453C95.1226 90.4744 96.1379 92.2904 96.4724 94.284C96.8068 96.2776 96.4398 98.3256 95.4337 100.079C94.4277 101.832 92.8449 103.183 90.955 103.9C89.065 104.617 86.9848 104.657 85.0688 104.013C83.1527 103.369 81.5193 102.08 80.4467 100.366C79.3742 98.653 78.9288 96.6206 79.1866 94.6156C79.4443 92.6107 80.3892 90.757 81.8603 89.3705C83.3314 87.984 85.2377 87.1504 87.2544 87.0117L87.8417 95.7319Z"
      fill="#29292F"
    />
    <path
      d="M87.831 87.3737C89.4846 87.3729 91.1012 87.8626 92.4764 88.7807C93.8516 89.6988 94.9237 91.0041 95.557 92.5316C96.1903 94.0591 96.3564 95.7401 96.0342 97.3619C95.7121 98.9838 94.9162 100.474 93.7472 101.643C92.5783 102.813 91.0887 103.609 89.467 103.932C87.8453 104.255 86.1643 104.09 84.6365 103.457C83.1088 102.824 81.803 101.753 80.8842 100.378C79.9655 99.0032 79.4751 97.3868 79.4751 95.7333C79.4781 93.5171 80.3598 91.3925 81.9269 89.8254C83.494 88.2583 85.6185 87.3766 87.8348 87.3737H87.831ZM87.8348 87.002C86.1082 87.0034 84.4208 87.5168 82.9859 88.4771C81.551 89.4374 80.4331 90.8015 79.7733 92.3971C79.1136 93.9926 78.9418 95.748 79.2795 97.4412C79.6173 99.1344 80.4494 100.69 81.6708 101.91C82.8922 103.13 84.448 103.961 86.1415 104.297C87.835 104.634 89.5902 104.46 91.1852 103.799C92.7803 103.138 94.1435 102.019 95.1026 100.583C96.0616 99.1477 96.5735 97.4599 96.5735 95.7333C96.574 94.5865 96.3485 93.4509 95.9099 92.3914C95.4713 91.3318 94.8281 90.3691 94.0173 89.5582C93.2064 88.7473 92.2437 88.1042 91.1841 87.6656C90.1246 87.227 88.9889 87.0015 87.8422 87.002H87.8348Z"
      fill="#29292F"
    />
    <path
      d="M86.8025 23.7891H33.9731V38.5973H86.8025V23.7891Z"
      fill="#FFE9A4"
    />
    <path
      d="M19.3508 26.9548H13.3496V35.5984H15.0289V32.2027H18.7827V30.7086H15.0289V28.4613H19.3508V26.9548Z"
      fill="#29292F"
    />
    <path
      d="M22.9795 35.7466C24.8811 35.7466 26.2765 34.3883 26.2765 32.4126C26.2765 30.4493 24.8811 29.091 22.9795 29.091C21.1026 29.091 19.7073 30.4493 19.7073 32.4126C19.7073 34.3883 21.1026 35.7466 22.9795 35.7466ZM22.9795 34.3389C22.0411 34.3389 21.3372 33.6351 21.3372 32.4126C21.3372 31.2025 22.0411 30.511 22.9795 30.511C23.9303 30.511 24.6465 31.2025 24.6465 32.4126C24.6465 33.6351 23.9303 34.3389 22.9795 34.3389Z"
      fill="#29292F"
    />
    <path
      d="M30.4364 29.091C29.7696 29.091 29.1892 29.4121 28.8311 30.153V29.2392H27.2383V35.5984H28.8311V32.2645C28.8311 31.326 29.3621 30.7951 30.103 30.7951H30.7698V29.091H30.4364Z"
      fill="#29292F"
    />
    <path
      d="M41.7368 35.7466C43.8606 35.7466 45.1572 34.7094 45.1572 33.1412C45.1572 31.857 44.3052 31.0297 42.527 30.5604L41.6133 30.3258C40.7119 30.0912 40.1439 29.8319 40.1439 29.2145C40.1439 28.6465 40.7119 28.2761 41.6627 28.2761C42.6258 28.2761 43.3914 28.7453 43.589 29.7578L45.0954 29.375C44.7991 27.6957 43.4161 26.8066 41.638 26.8066C39.724 26.8066 38.4275 27.8315 38.4275 29.3009C38.4275 30.5975 39.2301 31.4125 40.8971 31.8817L41.7985 32.1163C42.9345 32.425 43.4655 32.6967 43.4655 33.277C43.4655 33.8821 42.7987 34.2772 41.7368 34.2772C40.6007 34.2772 39.8352 33.5981 39.5635 32.5732L38.0941 33.0671C38.5386 34.9316 39.971 35.7466 41.7368 35.7466Z"
      fill="#FF9D33"
    />
    <path
      d="M48.801 29.091C47.5415 29.091 46.4302 29.622 45.998 30.9679L47.3192 31.5236C47.5538 30.8815 48.0354 30.511 48.7393 30.511C49.5666 30.511 50.0605 30.9062 50.0605 31.7582V32.3386C49.6901 31.9928 49.1344 31.7829 48.4059 31.7829C46.85 31.7829 45.8375 32.5608 45.8375 33.7586C45.8375 35.0057 46.813 35.7466 48.2947 35.7466C49.1344 35.7466 49.7888 35.4873 50.1716 34.981V35.5984H51.6534V31.5977C51.6534 29.8813 50.3322 29.091 48.801 29.091ZM48.7887 34.5859C48.0107 34.5859 47.4798 34.2895 47.4798 33.7462C47.4798 33.2029 48.0107 32.8942 48.7887 32.8942C49.5666 32.8942 50.0975 33.2029 50.0975 33.7462C50.0975 34.2895 49.5666 34.5859 48.7887 34.5859Z"
      fill="#FF9D33"
    />
    <path
      d="M56.0248 29.091C55.358 29.091 54.7776 29.4121 54.4195 30.153V29.2392H52.8267V35.5984H54.4195V32.2645C54.4195 31.326 54.9505 30.7951 55.6914 30.7951H56.3582V29.091H56.0248Z"
      fill="#FF9D33"
    />
    <path
      d="M59.6055 29.091C58.346 29.091 57.2347 29.622 56.8025 30.9679L58.1238 31.5236C58.3584 30.8815 58.84 30.511 59.5438 30.511C60.3711 30.511 60.865 30.9062 60.865 31.7582V32.3386C60.4946 31.9928 59.9389 31.7829 59.2104 31.7829C57.6545 31.7829 56.642 32.5608 56.642 33.7586C56.642 35.0057 57.6175 35.7466 59.0993 35.7466C59.9389 35.7466 60.5934 35.4873 60.9762 34.981V35.5984H62.4579V31.5977C62.4579 29.8813 61.1367 29.091 59.6055 29.091ZM59.5932 34.5859C58.8153 34.5859 58.2843 34.2895 58.2843 33.7462C58.2843 33.2029 58.8153 32.8942 59.5932 32.8942C60.3711 32.8942 60.9021 33.2029 60.9021 33.7462C60.9021 34.2895 60.3711 34.5859 59.5932 34.5859Z"
      fill="#FF9D33"
    />
    <path
      d="M66.9652 29.091C66.249 29.091 65.6069 29.375 65.2241 30.0665V26.9548H63.6312V35.5984H65.2241V31.857C65.2241 30.9803 65.7674 30.474 66.5206 30.474C67.1627 30.474 67.6319 30.9432 67.6319 31.7705V35.5984H69.2248V31.4989C69.2248 30.0418 68.2617 29.091 66.9652 29.091Z"
      fill="#FF9D33"
    />
    <path
      d="M78.4267 30.4864H74.5865V26.9548H72.9072V35.5984H74.5865V31.9805H78.4267V35.5984H80.1061V26.9548H78.4267V30.4864Z"
      fill="#FF9D33"
    />
    <path
      d="M82.2809 35.7466C82.8983 35.7466 83.3304 35.2897 83.3304 34.6723C83.3304 34.0426 82.8983 33.5981 82.2809 33.5981C81.6511 33.5981 81.2189 34.0426 81.2189 34.6723C81.2189 35.2897 81.6511 35.7466 82.2809 35.7466Z"
      fill="#FF9D33"
    />
    <path
      d="M6.24902 7.98507L6.86234 7.61336C6.93981 7.79729 7.07191 7.95297 7.24078 8.05935C7.40965 8.16572 7.60712 8.21768 7.80647 8.20813C8.27853 8.20813 8.54988 8.0334 8.54988 7.76205C8.54988 7.49071 8.31942 7.39035 7.80647 7.2491L7.40503 7.14501C6.68764 6.93314 6.34195 6.5726 6.34195 5.99646C6.34195 5.34597 6.91809 4.88134 7.76558 4.88134C8.05819 4.85881 8.35093 4.92339 8.60691 5.06692C8.8629 5.21046 9.07067 5.42655 9.20407 5.68796L8.60191 6.00018C8.52704 5.84874 8.40824 5.72338 8.26103 5.6405C8.11382 5.55761 7.94505 5.52104 7.77673 5.53555C7.3567 5.53555 7.10394 5.69909 7.10394 5.95185C7.10394 6.20461 7.34555 6.32354 7.72841 6.4462L8.12985 6.55029C8.9253 6.75845 9.30072 7.12646 9.30072 7.69517C9.30072 8.39026 8.72458 8.85117 7.78416 8.85117C7.47111 8.87619 7.15773 8.80711 6.8842 8.65279C6.61068 8.49848 6.3895 8.26595 6.24902 7.98507Z"
      fill="#FCFBF7"
    />
    <path
      d="M12.4603 7.05112V8.813H11.7949V8.54166C11.6909 8.6573 11.5618 8.74762 11.4175 8.8056C11.2731 8.86359 11.1174 8.88773 10.9623 8.87621C10.3044 8.87621 9.87695 8.54911 9.87695 7.99527C9.87695 7.44143 10.3267 7.11805 11.0181 7.11805C11.2883 7.10036 11.5549 7.18833 11.7615 7.36339V7.10689C11.7615 6.73518 11.5199 6.55305 11.1259 6.55305C11.0004 6.5461 10.8754 6.57273 10.7636 6.63023C10.6519 6.68773 10.5575 6.77402 10.4903 6.88015L9.9959 6.47501C10.1233 6.29051 10.2965 6.14239 10.4986 6.04527C10.7007 5.94815 10.9245 5.90538 11.1482 5.92117C11.8247 5.92117 12.4603 6.28913 12.4603 7.05112ZM11.7689 7.98783C11.7689 7.74622 11.5273 7.61612 11.1854 7.61612C10.8434 7.61612 10.5981 7.74994 10.5981 7.98783C10.5981 8.22572 10.8397 8.35953 11.1854 8.35953C11.531 8.35953 11.7689 8.22943 11.7689 7.98783Z"
      fill="#FCFBF7"
    />
    <path
      d="M14.0956 8.81397C13.9836 8.82621 13.8703 8.81285 13.7642 8.77486C13.6582 8.73687 13.5621 8.67528 13.4834 8.59472C13.4046 8.51416 13.3452 8.41676 13.3096 8.30986C13.274 8.20297 13.2631 8.08933 13.2779 7.97763V4.69922H13.9878V7.93675C13.9878 8.11145 14.0622 8.20441 14.2332 8.20441H14.4264V8.81397H14.0956Z"
      fill="#FCFBF7"
    />
    <path
      d="M17.6342 7.57151H15.6493C15.6472 7.66594 15.6645 7.7598 15.7002 7.84725C15.7359 7.93469 15.7893 8.01383 15.8569 8.07974C15.9246 8.14566 16.0051 8.19696 16.0934 8.23039C16.1818 8.26381 16.2761 8.27865 16.3704 8.27403C16.5075 8.28263 16.6444 8.25527 16.7677 8.19463C16.8909 8.13399 16.9961 8.04222 17.0729 7.92838L17.5636 8.3298C17.4225 8.50921 17.2407 8.65239 17.0331 8.74742C16.8256 8.84245 16.5984 8.88659 16.3704 8.87619C16.1748 8.88453 15.9796 8.85147 15.7977 8.77914C15.6157 8.70681 15.4511 8.59685 15.3146 8.45648C15.1781 8.31612 15.0728 8.14852 15.0056 7.96463C14.9383 7.78073 14.9107 7.58469 14.9245 7.38938C14.9072 7.19862 14.9304 7.00638 14.9923 6.82515C15.0543 6.64392 15.1537 6.47777 15.2842 6.33751C15.4146 6.19726 15.5731 6.08603 15.7494 6.01109C15.9257 5.93616 16.1157 5.89917 16.3072 5.90256C17.0915 5.90256 17.6379 6.49357 17.6379 7.38938C17.6379 7.44513 17.6379 7.53434 17.6342 7.57151ZM15.6605 7.08832H16.9243C16.8499 6.67201 16.6195 6.49355 16.3072 6.49355C16.1428 6.4875 15.9827 6.54658 15.8616 6.65795C15.7405 6.76931 15.6682 6.92398 15.6605 7.08832Z"
      fill="#FCFBF7"
    />
    <path
      d="M18.1948 8.19697L18.7152 7.89586C18.7754 8.02877 18.8752 8.13978 19.001 8.21366C19.1268 8.28754 19.2724 8.32066 19.4177 8.30845C19.7486 8.30845 19.9456 8.20438 19.9456 8.03339C19.9456 7.86241 19.7932 7.79922 19.4475 7.71001L19.1724 7.64313C18.5368 7.48701 18.2654 7.21196 18.2654 6.76591C18.2654 6.26411 18.7041 5.92214 19.3806 5.92214C19.6263 5.9018 19.8725 5.95621 20.0867 6.07827C20.301 6.20032 20.4733 6.3843 20.5812 6.60606L20.0162 6.86996C19.9594 6.75168 19.8685 6.6531 19.7552 6.58687C19.642 6.52063 19.5115 6.48976 19.3806 6.49825C19.0944 6.49825 18.9234 6.60606 18.9234 6.75103C18.9234 6.89599 19.1278 6.99635 19.44 7.07441L19.7188 7.14501C20.3135 7.28626 20.6109 7.57249 20.6109 7.99995C20.6109 8.52034 20.1314 8.87717 19.4066 8.87717C19.1593 8.90123 18.9106 8.84892 18.6939 8.7273C18.4773 8.60568 18.3031 8.42061 18.1948 8.19697Z"
      fill="#FCFBF7"
    />
    <path
      d="M24.3395 6.24018C24.3395 7.00589 23.8117 7.4891 22.8936 7.4891H22.1501V8.81235H21.4067V4.97266H22.8936C23.8117 4.97266 24.3395 5.46704 24.3395 6.24018ZM22.8527 6.84606C23.3024 6.84606 23.5701 6.64534 23.5701 6.24018C23.5701 5.83502 23.3024 5.6343 22.8527 5.6343H22.1613V6.84606H22.8527Z"
      fill="#FCFBF7"
    />
    <path
      d="M24.834 7.39766C24.8392 7.10959 24.9294 6.82948 25.0933 6.59254C25.2572 6.35561 25.4876 6.17243 25.7553 6.06607C26.0231 5.95971 26.3163 5.93491 26.5982 5.99478C26.88 6.05466 27.1378 6.19653 27.3392 6.40256C27.5406 6.6086 27.6766 6.86962 27.73 7.15273C27.7835 7.43585 27.752 7.72842 27.6396 7.9937C27.5272 8.25897 27.3388 8.48509 27.0982 8.64359C26.8576 8.80209 26.5755 8.8859 26.2874 8.88448C26.0921 8.89041 25.8976 8.85573 25.7164 8.78266C25.5351 8.70959 25.371 8.59975 25.2344 8.46001C25.0978 8.32026 24.9917 8.15368 24.9228 7.97083C24.8539 7.78797 24.8236 7.5928 24.834 7.39766ZM27.0271 7.39766C27.0271 7.2005 26.9488 7.01142 26.8093 6.872C26.6699 6.73259 26.4808 6.65425 26.2837 6.65425C26.0865 6.65425 25.8974 6.73259 25.758 6.872C25.6186 7.01142 25.5403 7.2005 25.5403 7.39766C25.5403 7.94035 25.8525 8.2526 26.2837 8.2526C26.3914 8.25382 26.4982 8.23157 26.5965 8.18744C26.6948 8.14332 26.7824 8.07833 26.8531 7.99701C26.9238 7.91569 26.976 7.82 27.006 7.7165C27.0361 7.61301 27.0433 7.50421 27.0271 7.39766Z"
      fill="#FCFBF7"
    />
    <path
      d="M30.9523 7.26697C31.022 7.46218 31.0718 7.66392 31.101 7.86913H31.1233C31.151 7.6632 31.1932 7.45949 31.2497 7.25953L31.6214 5.98828H32.3648L31.5099 8.81323H30.7813L30.4096 7.53831C30.3492 7.34877 30.3032 7.1549 30.2721 6.95843H30.2498C30.2186 7.1549 30.1727 7.34877 30.1123 7.53831L29.7405 8.81323H29.0455L28.1831 5.98828H28.9265L29.2982 7.26697C29.3514 7.46625 29.3923 7.66859 29.4209 7.87285H29.4395C29.4752 7.66861 29.5261 7.46732 29.5919 7.27069L29.9636 5.98828H30.588L30.9523 7.26697Z"
      fill="#FCFBF7"
    />
    <path
      d="M35.4609 7.57151H33.476C33.4738 7.66594 33.4911 7.7598 33.5269 7.84725C33.5626 7.93469 33.6159 8.01383 33.6836 8.07974C33.7513 8.14566 33.8318 8.19696 33.9201 8.23039C34.0085 8.26381 34.1027 8.27865 34.1971 8.27403C34.3341 8.28226 34.4709 8.25473 34.5941 8.19413C34.7172 8.13353 34.8225 8.04195 34.8996 7.92838L35.3903 8.3298C35.2492 8.50921 35.0673 8.65239 34.8598 8.74742C34.6523 8.84245 34.4251 8.88659 34.1971 8.87619C34.0015 8.88453 33.8063 8.85147 33.6243 8.77914C33.4424 8.70681 33.2778 8.59685 33.1413 8.45648C33.0048 8.31612 32.8994 8.14852 32.8322 7.96463C32.765 7.78073 32.7374 7.58469 32.7512 7.38938C32.7339 7.19862 32.757 7.00638 32.819 6.82515C32.8809 6.64392 32.9804 6.47777 33.1108 6.33751C33.2413 6.19726 33.3998 6.08603 33.576 6.01109C33.7523 5.93616 33.9424 5.89917 34.1339 5.90256C34.9182 5.90256 35.4646 6.49357 35.4646 7.38938C35.4646 7.44513 35.4646 7.53434 35.4609 7.57151ZM33.4871 7.08832H34.7509C34.6766 6.67201 34.4461 6.49355 34.1339 6.49355C33.9695 6.4875 33.8093 6.54658 33.6882 6.65795C33.5671 6.76931 33.4948 6.92398 33.4871 7.08832Z"
      fill="#FCFBF7"
    />
    <path
      d="M37.7507 5.92163V6.66504H37.4719C37.3903 6.66533 37.3097 6.68305 37.2356 6.71704C37.1614 6.75102 37.0953 6.8005 37.0418 6.8621C36.9883 6.9237 36.9486 6.99602 36.9253 7.07422C36.9021 7.15242 36.8958 7.23469 36.9069 7.31552V8.80234H36.2007V5.97739H36.9069V6.38254C36.9628 6.23992 37.0613 6.11802 37.189 6.03352C37.3168 5.94902 37.4675 5.90605 37.6206 5.91047L37.7507 5.92163Z"
      fill="#FCFBF7"
    />
    <path
      d="M214.986 60.1602C216.365 60.1862 216.815 61.2753 215.919 63.0186C215.023 64.7619 213.585 63.6728 213.585 63.6728"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M214.54 69.3008C214.54 69.3008 213.053 71.7168 213.707 76.7088"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M217.875 52.3027H138.917V106.646H217.875V52.3027Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M168.709 78.6348H160.257V103.714H168.709V78.6348Z"
      fill="#FF9D33"
    />
    <path
      d="M214.648 78.6348H206.196V103.714H214.648V78.6348Z"
      fill="#FF9D33"
    />
    <path
      d="M180.176 85.1211H171.724V103.714H180.176V85.1211Z"
      fill="#FF9D33"
    />
    <path
      d="M157.238 88.3945H148.785V103.712H157.238V88.3945Z"
      fill="#FF9D33"
    />
    <path
      d="M191.646 66.9141H183.194V103.713H191.646V66.9141Z"
      fill="#FF9D33"
    />
    <path
      d="M203.114 83.5586H194.661V103.712H203.114V83.5586Z"
      fill="#FF9D33"
    />
    <path
      d="M141.689 67.5723H144.303"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M141.689 79.6523H144.303"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M141.689 91.7363H144.303"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M144.306 103.817H141.689V55.4883H144.306"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M18.7529 98.1112C24.1786 98.1112 28.577 93.7128 28.577 88.287C28.577 82.8613 24.1786 78.4629 18.7529 78.4629C13.3271 78.4629 8.92871 82.8613 8.92871 88.287C8.92871 93.7128 13.3271 98.1112 18.7529 98.1112Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.400222}
      strokeMiterlimit={10}
    />
    <path
      d="M19.8941 78.5293L18.7529 88.2865L24.191 96.4641C25.8688 95.3521 27.1642 93.7513 27.9018 91.8785C28.6394 90.0057 28.7835 87.9514 28.3145 85.994C27.8455 84.0366 26.7862 82.2706 25.28 80.9354C23.7738 79.6002 21.8936 78.7602 19.8941 78.5293Z"
      fill="#FF9D33"
      stroke="#29292F"
      strokeWidth={0.400222}
    />
  </svg>
);
const SvgDemos = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgDemos;
